import { PUBLIC_ENVIRONMENT } from '../../config/env';

export const getTxExplorer = (txhash: string) => {
  return `${PUBLIC_ENVIRONMENT.REACT_APP_ARBITRUM_EXPLORER_URL}/tx/${txhash}`;
};

export const getBlockExplorer = (blockNumber: number) => {
  return `${PUBLIC_ENVIRONMENT.REACT_APP_ARBITRUM_EXPLORER_URL}/block/${blockNumber}/transactions`;
};
